module.exports = __webpack_public_path__ + "static/13-dbc0eb9ba27e1105468b8e6cd2fd10e7.jpg";